import React, { useState } from 'react'
import Style from './Login.module.css'
import Input from '../../Components/Input/Input'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Button from '../../Components/Button/Button'
import { faBiking, faHandshake} from '@fortawesome/free-solid-svg-icons'
import { errorToast } from '../../Utils/Toast/Toast'
import { Link, useHistory } from 'react-router-dom'
const Login = () => {
    const history=useHistory()
    const[phoneNumber,setPhoneNumber]=useState('')
    const setPhoneNumberHandler=(e)=>{
        e.preventDefault();
        if(phoneNumber==='') errorToast("شماره تماس وارد نشده")
        else{
            history.push('/confirm',phoneNumber)
        }
       
    }
    return (
        <div className={Style.pageHolder}>
            <div className={Style.ImageHolder}><img src="./Assets/Images/Auth/food-delivery.jpg" alt="barest" /></div>
            <form className={Style.formHolder}>
            <FontAwesomeIcon icon={faBiking} />
            <p>ورود تحویل دهندگان</p>
            <Input 
            inputtype={'text'} 
            placeholder="شماره همراه خودرا وارد کنید..." 
            type={'tel'}
            value={phoneNumber?phoneNumber:''}
            onChange={e=>setPhoneNumber(e.target.value)}
            maxLength='11'
            />
            <div className={Style.BtnHolder}>
                <Button Value={'ارسال'} ClassBtn={'confirmBtn'} ClickHandler={setPhoneNumberHandler}/>
            </div>
            </form>
            <Link className={Style.cooperationRequest} to="/cooperationrequest">در خواست همکاری <FontAwesomeIcon icon={faHandshake}/></Link>
        </div>
    )
}
export default Login
